import React from 'react';
import PropTypes from 'prop-types';

import { parseTireSize } from '../../../../../../../../../../shared/utils/fitment/fitment';

import './fitment-tire-size-option-line.scss';

function FitmentTireSizeOptionLine(props) {
  const { assemblyDescription, isNormalizedSize, label } = props;
  const tireSize = parseTireSize(assemblyDescription);

  return (
    <span className="fitment-tire-size-option-line" styleName="line">
      <span
        className="fitment-tire-size-option-line__description"
        styleName={label ? 'description-with-label' : 'description'}
      >
        {isNormalizedSize && tireSize
          ? `${tireSize.width}/${tireSize.aspectRatio} R${tireSize.diameter}`
          : assemblyDescription}

        {label && (
          <span
            className="fitment-tire-size-option-line__label"
            styleName="label"
          >
            {label}
          </span>
        )}
      </span>
      <span
        className="fitment-tire-size-option-line__wheel-size"
        styleName="wheel-size"
      >
        <span className="fitment-tire-size-option-line__diameter">
          {tireSize?.diameter}&#8221;
        </span>
        <span className="fitment-tire-size-option-line__wheels">wheels</span>
      </span>
    </span>
  );
}

FitmentTireSizeOptionLine.propTypes = {
  assemblyDescription: PropTypes.string,
  isNormalizedSize: PropTypes.bool,
  label: PropTypes.string
};

export default FitmentTireSizeOptionLine;
